/**
 * Whether this bundle is a preview or local development build. Decided at
 * build time from the environment, never from the hostname, and fail-closed:
 * a build that does not say it is a preview (NEXT_PUBLIC_VERCEL_ENV unset or
 * anything but `preview`) is treated as production. next.config.js copies
 * VERCEL_ENV into NEXT_PUBLIC_VERCEL_ENV so Vercel builds always say which
 * they are.
 *
 * Every offers override that could move funded escrows or trust another key
 * (the isolated offers API, the v2 routing switch, the co-signer key) is
 * honoured only when this is true.
 */
export const OFFERS_PREVIEW_BUILD =
	process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' || process.env.NODE_ENV === 'development'
